import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

const ImageIcon = ({ src, svgIcon: SvgIconComponent, resource, field }) => {
    // Determine the source of the image
    let imageSrc = src;

    if (resource && field) {
        imageSrc = resource[field];
    }

    return (
        <Box sx={{ width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {SvgIconComponent ? (
                <SvgIconComponent style={{ width: '100%', height: '100%' }} />
            ) : (
                <Box
                    component="img"
                    src={imageSrc}
                    alt="Icon"
                    sx={{ width: '100%', height: '100%' }} // Adjust size as needed
                />
            )}
        </Box>
    );
};

ImageIcon.propTypes = {
    src: PropTypes.string, // URL or relative path to the image
    svgIcon: PropTypes.elementType, // React component for SVG icons
    resource: PropTypes.object, // Resource object that contains the image field
    field: PropTypes.string, // Field name within the resource object that holds the image URL
};

ImageIcon.defaultProps = {
    src: null,
    svgIcon: null,
    resource: null,
    field: null,
};

export default ImageIcon;